import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { AccessGuard } from "../access/AccessGuard";
import { ServiceLayout } from "../menu/ServiceLayout";
import type { RouterContext } from "../RouterContext";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <AccessGuard>
      <ServiceLayout>
        <Outlet />
      </ServiceLayout>
    </AccessGuard>
  );
}
